export default __webpack_public_path__ + "static/media/low_resilience_score.c3affbb6.svg";